//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Toggleable from '../../mixins/toggleable'

export default {
  name: 'alert',

  data () {
    return {
      isActive: this.value
    }
  },

  mixins: [Toggleable],

  props: {
    dismissible: Boolean,

    error: Boolean,

    hideIcon: Boolean,

    icon: String,

    info: Boolean,

    success: Boolean,

    warning: Boolean
  },

  computed: {
    classes () {
      return {
        'alert--dismissible': this.dismissible,
        'alert--error': this.error,
        'alert--info': this.info,
        'alert--success': this.success,
        'alert--warning': this.warning
      }
    },

    mdIcon () {
      if (this.icon) {
        return this.icon
      }

      switch (true) {
        case this.error:
          return 'warning'
        case this.info:
          return 'info'
        case this.success:
          return 'check_circle'
        case this.warning:
          return 'priority_high'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/alerts/Alert.vue